import { Controller } from 'stimulus';
import A11yDialog from 'a11y-dialog';

class Modal extends Controller {
  connect() {
    this.dialog = new A11yDialog(this.element);

    this.dialog.on('show', () => {
      Modal.toggleDocumentLock(true);
    });

    this.dialog.on('hide', () => {
      Modal.toggleDocumentLock(false);
    });

    this.dialog.on('destroy', () => {
      Modal.toggleDocumentLock(false);
    });
  }

  disconnect() {
    if (this.dialog && typeof this.dialog.destroy === 'function') {
      this.dialog.destroy();
    }
  }

  static toggleDocumentLock(state) {
    document.documentElement.classList[state ? 'add' : 'remove']('is-locked');
  }
}

Modal.targets = [
  //
];

export default Modal;
